export default __webpack_public_path__ + "static/media/contact.1f4117df.jpg";